<div
  [ngClass]="dialogConfig.fullscreen ? 'fullscreenwrapper' : 'wrapper'"
  *ngIf="show"
  [ngStyle]="{ 'z-index': zIndex }"
>
  <div class="dialog">
    <i class="fas fa-times clickable" (click)="onFeedback(false)"></i>
    <div class="header">
      <span class="headerText">{{ dialogConfig.headerText }}</span>
    </div>
    <div class="body">
      <span *ngIf="dialogConfig.warningText"
        >{{ dialogConfig.warningText }}<br
      /></span>
      <span [innerHTML]="dialogConfig.detailText"></span>
    </div>
    <div class="footer">
      <span class="cancelBtn clickable" (click)="onFeedback(false)">{{
        btnConfig.cancel
      }}</span>
      <div
        class="btnContainer clickable {{ btnConfig.class }}"
        (click)="onFeedback(true)"
      >
        <img class="btnImg" src="{{ btnConfig.img }}" />
        <span>{{ btnConfig.text }}</span>
      </div>
    </div>
  </div>
</div>
